const a = ["ars-ars.de", "ars-mia.de"];
export {
  a as externalImagePaths
};
